(function () {
  'use strict';

  /*
   * XED & CO
   * Shopify Horizon 4.2.0
   *
   * REQUIRED SIZE SELECTION
   *
   * - Customer must manually select Size
   * - Default Horizon Size does NOT count
   * - Selected Size can be added to cart
   * - Buy Now is hidden separately with CSS
   */

  let customerSelectedSize = false;


  /* =====================================================
     FIND SIZE FIELDSET
  ===================================================== */

  function getSizeFieldset() {

    const fieldsets =
      document.querySelectorAll(
        'variant-picker fieldset'
      );

    for (const fieldset of fieldsets) {

      const legend =
        fieldset.querySelector('legend');

      if (!legend) continue;

      const text =
        legend.textContent
          .trim()
          .toLowerCase();

      if (text === 'size') {
        return fieldset;
      }
    }

    return null;
  }


  /* =====================================================
     SHOW SIZE ERROR
  ===================================================== */

  function showSizeError() {

    const fieldset =
      getSizeFieldset();

    if (!fieldset) return;

    let error =
      fieldset.querySelector(
        '.size-required-error'
      );

    if (!error) {

      error =
        document.createElement('div');

      error.className =
        'size-required-error';

      error.setAttribute(
        'role',
        'alert'
      );

      error.textContent =
        'Please select a size before adding this product to your order.';

      fieldset.appendChild(error);
    }

    error.style.display =
      'block';

    fieldset.classList.add(
      'size-selection-error'
    );

    fieldset.scrollIntoView({
      behavior: 'smooth',
      block: 'center'
    });
  }


  /* =====================================================
     HIDE SIZE ERROR
  ===================================================== */

  function hideSizeError() {

    document
      .querySelectorAll(
        '.size-required-error'
      )
      .forEach(function (error) {

        error.style.display =
          'none';

      });

    document
      .querySelectorAll(
        '.size-selection-error'
      )
      .forEach(function (element) {

        element.classList.remove(
          'size-selection-error'
        );

      });
  }


  /* =====================================================
     CUSTOMER CLICKS SIZE
  ===================================================== */

  document.addEventListener(
    'click',
    function (event) {

      const input =
        event.target.closest(
          'variant-picker input[type="radio"][data-option-name="Size"]'
        );

      if (!input) return;


      /*
       * The customer has manually clicked
       * a Size.
       */

      customerSelectedSize =
        true;


      hideSizeError();

    },
    true
  );


  /* =====================================================
     ADD TO CART
  ===================================================== */

  document.addEventListener(
    'click',
    function (event) {

      const button =
        event.target.closest(
          'button[name="add"]'
        );

      if (!button) return;


      /*
       * Find Size.
       */

      const sizeFieldset =
        getSizeFieldset();


      /*
       * Products without Size are
       * unaffected.
       */

      if (!sizeFieldset) {
        return;
      }


      /*
       * Customer has NOT manually
       * selected Size.
       */

      if (!customerSelectedSize) {

        event.preventDefault();

        event.stopImmediatePropagation();

        showSizeError();

        return false;
      }


      /*
       * Customer DID select Size.
       *
       * IMPORTANT:
       * Do nothing here.
       *
       * This allows Horizon to continue
       * with its normal Add to Cart process.
       */

      return;

    },
    true
  );


  /* =====================================================
     ADD TO CART FORM SUBMISSION
  ===================================================== */

  document.addEventListener(
    'submit',
    function (event) {

      const form =
        event.target;


      if (
        !form.matches(
          'form[data-type="add-to-cart-form"]'
        )
      ) {
        return;
      }


      const sizeFieldset =
        getSizeFieldset();


      /*
       * Products without Size are
       * unaffected.
       */

      if (!sizeFieldset) {
        return;
      }


      /*
       * Customer has NOT selected Size.
       */

      if (!customerSelectedSize) {

        event.preventDefault();

        event.stopImmediatePropagation();

        showSizeError();

        return false;
      }


      /*
       * Customer selected Size.
       *
       * DO NOTHING.
       *
       * Horizon handles the normal
       * form submission.
       */

      return;

    },
    true
  );


  /* =====================================================
     INITIAL STATE
  ===================================================== */

  /*
   * Horizon may automatically select a
   * default variant such as M.
   *
   * That does NOT count as a customer
   * selection.
   */

  customerSelectedSize =
    false;

})();